var version = {
    "name":      "dativery",
    "buildDateCode": "20251120-102601",
    "buildDate": "Thu Nov 20 2025 10:26:01 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251120-102601",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;